import { render, staticRenderFns } from "./reginImageCheckedDialogItem.vue?vue&type=template&id=4ae84073&scoped=true&"
import script from "./reginImageCheckedDialogItem.vue?vue&type=script&lang=js&"
export * from "./reginImageCheckedDialogItem.vue?vue&type=script&lang=js&"
import style0 from "./reginImageCheckedDialogItem.vue?vue&type=style&index=0&id=4ae84073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae84073",
  null
  
)

export default component.exports